import { NativeCurrency, Token } from '@uniswap/sdk-core'
import { SupportedChainId } from 'constants/chains'
import { nativeOnChain } from 'constants/tokens'
import { useMemo } from 'react'
import {useAccount} from "wagmi";

export default function useNativeCurrency(): NativeCurrency | Token {
  const { chainId } = useAccount()
  return useMemo(
    () =>
      chainId
        ? nativeOnChain(chainId)
        : // display mainnet when not connected
          nativeOnChain(SupportedChainId.CRAT_TESTNET),
    [chainId]
  )
}
